import loadingIcon from 'images/LoadingSpinner.gif';
import React from 'react';

const loadingStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '5rem'
};

function Loading() {
  return (
    <div css={loadingStyle}>
      <img src={loadingIcon} alt='Loading...' />
    </div>
  );
}
export default Loading;
